// frontend/src/pages/PackageDetailPage.jsx
import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import {
  Loader2, ShoppingCart, Zap, Package, ImageOff, CheckCircle,
  CreditCard, Phone, ChevronDown, ChevronUp
} from 'lucide-react';
import api from '../services/api';
import { useCartStore } from '../store/cartStore';
import { useAuthStore } from '../store/authStore';
import { PageSEO } from '../components/SEO/PageSEO';
import config from '../config';

// ============================================================
// آیکون‌های پیام‌رسان‌ها
// ============================================================

const WhatsAppIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const TelegramIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const SoroushIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
    <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/>
  </svg>
);

const BaleIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
    <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z"/>
  </svg>
);

const EitaaIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
  </svg>
);

const RubikaIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
  </svg>
);

const MessengerIcon = ({ type, className }) => {
  switch(type) {
    case 'telegram': return <TelegramIcon className={className} />;
    case 'soroush': return <SoroushIcon className={className} />;
    case 'bale': return <BaleIcon className={className} />;
    case 'eitaa': return <EitaaIcon className={className} />;
    case 'rubika': return <RubikaIcon className={className} />;
    default: return <WhatsAppIcon className={className} />;
  }
};

export const PackageDetailPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [packageData, setPackageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addingToCart, setAddingToCart] = useState(false);
  const [productPrices, setProductPrices] = useState({});
  const [siteSettings, setSiteSettings] = useState(null);
  const [showFullDescription, setShowFullDescription] = useState(false);

  const { addPackageSimple } = useCartStore();
  const { isAuthenticated } = useAuthStore();

  // دریافت تنظیمات سایت
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get('/cms/settings/get_settings/');
        setSiteSettings(response.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    const fetchPackage = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/products/packages/${slug}/`);
        setPackageData(response.data);

        if (response.data.items && response.data.items.length > 0) {
          const prices = {};
          for (const item of response.data.items) {
            try {
              const productRes = await api.get(`/products/products/${item.product_slug}/`);
              prices[item.product] = productRes.data.final_price || productRes.data.price;
            } catch (err) {
              prices[item.product] = 0;
            }
          }
          setProductPrices(prices);
        }
      } catch (err) {
        console.error('Error fetching package:', err);
        setError(err.response?.data?.detail || 'خطا در دریافت اطلاعات پکیج');
      } finally {
        setLoading(false);
      }
    };
    fetchPackage();
  }, [slug]);

  const handleAddToCart = async () => {
    if (!packageData) return;
    setAddingToCart(true);
    const success = addPackageSimple(packageData);
    if (success) alert('محصولات پکیج به سبد خرید اضافه شد');
    setAddingToCart(false);
  };

  const handleBuyNow = async () => {
    if (!packageData) return;
    setAddingToCart(true);
    addPackageSimple(packageData);
    setAddingToCart(false);
    navigate('/cart');
  };

  const handleDirectCheckout = async () => {
    if (!isAuthenticated) {
      navigate('/login', { state: { from: `/packages/${slug}` } });
      return;
    }
    setAddingToCart(true);
    addPackageSimple(packageData);
    setAddingToCart(false);
    navigate('/checkout');
  };

  // ========== توابع تماس و پیام ==========
  const handlePriceOnCall = () => {
    const phoneNumber = packageData?.contact_phone || siteSettings?.contact_phone || config.CONTACT_PHONE;
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleMessenger = () => {
    const settings = siteSettings || {};
    const messengerType = settings.messenger_type || 'whatsapp';
    const phone = settings.messenger_phone || settings.contact_phone || config.CONTACT_WHATSAPP || '';
    const username = settings.messenger_username || '';
    const link = settings.messenger_link || '';

    let messengerLink = link;
    if (!messengerLink) {
      const cleanPhone = phone.replace(/^0/, '').replace(/[^0-9]/g, '');
      switch (messengerType) {
        case 'whatsapp': messengerLink = `https://wa.me/98${cleanPhone}`; break;
        case 'telegram': messengerLink = username ? `https://t.me/${username}` : `https://t.me/${cleanPhone}`; break;
        case 'soroush': messengerLink = `https://sapp.ir/${username || cleanPhone}`; break;
        case 'bale': messengerLink = `https://bale.ai/${username || cleanPhone}`; break;
        case 'eitaa': messengerLink = `https://eitaa.com/${username || cleanPhone}`; break;
        case 'rubika': messengerLink = `https://rubika.ir/${username || cleanPhone}`; break;
        default: messengerLink = `tel:${phone}`;
      }
    }
    if (messengerLink) window.open(messengerLink, '_blank');
  };

  const formatPrice = (price) => {
    if (!price && price !== 0) return '۰';
    return Number(price).toLocaleString('fa-IR');
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
      </div>
    );
  }

  if (error || !packageData) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Package className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h2 className="text-2xl font-bold text-gray-900 mb-2">پکیج یافت نشد</h2>
          <p className="text-gray-500 mb-4">{error || 'چیزی پیدا نشد'}</p>
          <Link to="/packages" className="text-blue-600 hover:underline">بازگشت به پکیج‌ها</Link>
        </div>
      </div>
    );
  }

  const packageItems = packageData.items || [];
  const finalPrice = Number(packageData.discount_price || packageData.total_price);
  const originalPrice = Number(packageData.total_price);
  const hasDiscount = originalPrice && finalPrice && originalPrice > finalPrice;
  const powerDisplay = packageData.power_display || `${packageData.power_value || packageData.power_rating} کیلووات`;
  const showPriceOnCall = packageData.show_price_on_call || false;

  // محاسبه مجموع قیمت محصولات
  let totalIndividualPrice = 0;
  const itemsWithPrices = packageItems.map(item => {
    const itemPrice = Number(productPrices[item.product] || 0);
    const itemQuantity = item.quantity || 1;
    const itemTotal = itemPrice * itemQuantity;
    totalIndividualPrice += itemTotal;
    return { ...item, price: itemPrice, quantity: itemQuantity, total: itemTotal };
  });

  const savings = totalIndividualPrice - finalPrice;
  const savingsPercent = totalIndividualPrice > 0 ? Math.round((savings / totalIndividualPrice) * 100) : 0;

  const seoTitle = packageData.meta_title || packageData.name;
  const seoDescription = packageData.meta_description || packageData.description?.replace(/<[^>]*>/g, '').substring(0, 160);
  const seoKeywords = packageData.meta_keywords;

  const settings = siteSettings || {};
  const messengerType = settings.messenger_type || 'whatsapp';
  const messengerNames = {
    'whatsapp': 'واتساپ',
    'telegram': 'تلگرام',
    'soroush': 'سروش',
    'bale': 'بله',
    'eitaa': 'ایتا',
    'rubika': 'روبیکا',
  };
  const messengerDisplayName = messengerNames[messengerType] || 'پیام';

  // تشخیص اینکه آیا توضیحات نیاز به دکمه "مشاهده بیشتر" دارد
  const plainDescription = packageData.description?.replace(/<[^>]*>/g, '') || '';
  const descriptionLength = plainDescription.length;
  const shouldShowReadMore = descriptionLength > 300;
  const displayDescription = showFullDescription 
    ? packageData.description 
    : packageData.description?.substring(0, 300) + (shouldShowReadMore ? '...' : '');

  return (
    <>
      <PageSEO title={seoTitle} description={seoDescription} keywords={seoKeywords} type="product" />
      
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <Link to="/packages" className="text-blue-600 hover:text-blue-800 mb-4 inline-block">
            ← بازگشت به پکیج‌ها
          </Link>

          <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
            {/* ========== هدر پکیج ========== */}
            <div className="p-6 border-b border-gray-200">
              <div className="flex flex-wrap items-center gap-2 mb-3">
                <Zap className="w-5 h-5 text-yellow-500" />
                <span className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-sm font-medium">
                  {powerDisplay}
                </span>
                {packageData.is_featured && (
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                    ویژه
                  </span>
                )}
                {showPriceOnCall && (
                  <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                    تماس برای قیمت
                  </span>
                )}
              </div>

              <h1 className="text-2xl md:text-3xl font-bold text-gray-900">{packageData.name}</h1>
            </div>

            {/* ========== بخش توضیحات (فقط نمایش) ========== */}
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-lg font-bold text-gray-900 mb-3">توضیحات پکیج</h2>
              
              <div 
                className="prose max-w-none text-gray-700 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: displayDescription || 'توضیحاتی برای این پکیج وجود ندارد.' }}
              />
              
              {shouldShowReadMore && (
                <button
                  onClick={() => setShowFullDescription(!showFullDescription)}
                  className="mt-3 text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1 transition"
                >
                  {showFullDescription ? (
                    <>
                      <ChevronUp className="w-4 h-4" />
                      مشاهده کمتر
                    </>
                  ) : (
                    <>
                      <ChevronDown className="w-4 h-4" />
                      مشاهده بیشتر
                    </>
                  )}
                </button>
              )}
            </div>

            {/* ========== محصولات داخل پکیج ========== */}
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
                <Package className="w-5 h-5 text-blue-600" />
                محصولات موجود در پکیج ({packageItems.length} مورد)
              </h2>

              {packageItems.length === 0 ? (
                <div className="text-center py-8 text-gray-500 bg-gray-50 rounded-lg">
                  <Package className="w-12 h-12 mx-auto text-gray-300 mb-2" />
                  <p>هیچ محصولی در این پکیج یافت نشد</p>
                </div>
              ) : (
                <div className="space-y-3">
                  {itemsWithPrices.map((item) => {
                    let imageUrl = null;
                    if (item.product_image) {
                      imageUrl = item.product_image.startsWith('http')
                        ? item.product_image
                        : config.getMediaUrl(item.product_image);
                    }

                    return (
                      <div key={item.id} className="flex gap-4 p-4 bg-gray-50 rounded-lg border border-gray-100 hover:border-blue-200 transition">
                        <div className="w-16 h-16 flex-shrink-0 bg-gray-200 rounded-lg overflow-hidden">
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              alt={item.product_name}
                              className="w-full h-full object-cover"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = '/placeholder-product.jpg';
                              }}
                            />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center text-gray-400">
                              <ImageOff className="w-6 h-6" />
                            </div>
                          )}
                        </div>

                        <div className="flex-1 flex flex-wrap items-center justify-between gap-2">
                          <div>
                            <Link
                              to={`/products/${item.product_slug}`}
                              className="font-bold text-gray-800 hover:text-blue-600 transition"
                            >
                              {item.product_name}
                            </Link>
                            <div className="text-sm text-gray-500">
                              تعداد: {item.quantity} عدد
                            </div>
                          </div>
                          <div className="text-left">
                            {item.price > 0 && (
                              <>
                                <div className="text-sm text-gray-500">قیمت واحد: {formatPrice(item.price)} تومان</div>
                                <div className="font-bold text-blue-600">{formatPrice(item.total)} تومان</div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* ========== قیمت و دکمه‌های اقدام ========== */}
            <div className="p-6">
              {showPriceOnCall ? (
                // ========== حالت "تماس برای قیمت" ==========
                <div className="bg-green-50 rounded-lg border border-green-200 p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <Phone className="w-6 h-6 text-green-600 flex-shrink-0" />
                    <div>
                      <span className="text-lg font-bold text-gray-800">تماس برای قیمت</span>
                      <p className="text-sm text-gray-600">برای استعلام قیمت این پکیج با ما تماس بگیرید</p>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <button
                      onClick={handlePriceOnCall}
                      className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-lg flex items-center justify-center gap-2 text-lg transition-colors"
                    >
                      <Phone className="w-5 h-5" />
                      تماس تلفنی
                    </button>
                    <button
                      onClick={handleMessenger}
                      className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg flex items-center justify-center gap-2 text-lg transition-colors"
                    >
                      <MessengerIcon type={messengerType} className="w-5 h-5" />
                      {messengerDisplayName}
                    </button>
                  </div>

                  <div className="text-center p-3 bg-white rounded-lg mt-4">
                    <p className="text-sm text-gray-600">
                      شماره تماس:
                      <span className="font-bold text-gray-800 mr-2">
                        {packageData.contact_phone || settings.contact_phone || config.CONTACT_PHONE || '021-88315658'}
                      </span>
                    </p>
                    <p className="text-xs text-gray-400 mt-1">پاسخگویی: شنبه تا پنجشنبه ۹ الی ۱۸</p>
                  </div>
                </div>
              ) : (
                // ========== حالت نمایش قیمت ==========
                <>
                  {totalIndividualPrice > 0 && (
                    <div className="mb-3 pb-3 border-b border-gray-100">
                      <div className="flex justify-between items-center">
                        <span className="text-gray-600">مجموع قیمت محصولات به صورت تکی:</span>
                        <span className="text-gray-500 line-through text-lg">{formatPrice(totalIndividualPrice)} تومان</span>
                      </div>
                    </div>
                  )}

                  <div className="flex flex-wrap justify-between items-center mb-4">
                    <span className="text-gray-600">قیمت پکیج (با تخفیف ویژه):</span>
                    <div className="text-left">
                      {hasDiscount && (
                        <span className="text-gray-400 line-through text-sm block">{formatPrice(originalPrice)} تومان</span>
                      )}
                      <span className="text-2xl font-bold text-green-600">{formatPrice(finalPrice)} تومان</span>
                    </div>
                  </div>

                  {savings > 0 && (
                    <div className="bg-green-50 p-3 rounded-lg mb-4 flex items-center gap-2 text-green-700">
                      <CheckCircle className="w-5 h-5" />
                      <span className="text-sm font-medium">
                        🎉 شما با خرید این پکیج، {formatPrice(savings)} تومان ({savingsPercent}%) صرفه‌جویی می‌کنید!
                      </span>
                    </div>
                  )}

                  <div className="flex flex-col sm:flex-row gap-3">
                    <button
                      onClick={handleAddToCart}
                      disabled={addingToCart}
                      className={`flex-1 py-3 rounded-lg font-bold flex items-center justify-center gap-2 transition ${
                        addingToCart ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 text-white'
                      }`}
                    >
                      {addingToCart ? (
                        <><Loader2 className="w-5 h-5 animate-spin" /> در حال افزودن...</>
                      ) : (
                        <><ShoppingCart className="w-5 h-5" /> افزودن به سبد خرید</>
                      )}
                    </button>

                    <button
                      onClick={handleBuyNow}
                      disabled={addingToCart}
                      className={`flex-1 py-3 rounded-lg font-bold flex items-center justify-center gap-2 transition ${
                        addingToCart ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700 text-white'
                      }`}
                    >
                      مشاهده سبد خرید
                    </button>

                    <button
                      onClick={handleDirectCheckout}
                      disabled={addingToCart}
                      className={`flex-1 py-3 rounded-lg font-bold flex items-center justify-center gap-2 transition ${
                        addingToCart ? 'bg-gray-400 cursor-not-allowed' : 'bg-purple-600 hover:bg-purple-700 text-white'
                      }`}
                    >
                      <CreditCard className="w-5 h-5" />
                      خرید سریع
                    </button>
                  </div>
                </>
              )}

              <p className="text-xs text-gray-400 text-center mt-4">
                {showPriceOnCall
                  ? 'برای اطلاع از قیمت پکیج و مشاوره رایگان با ما تماس بگیرید.'
                  : `با خرید این پکیج، ${packageItems.length} محصول به سبد خرید شما اضافه می‌شود و از تخفیف ویژه پکیج بهره‌مند می‌شوید.`
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};